var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwipe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.06,
    height: 59.324,
    viewBox: "0 0 62.06 59.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#112436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#235684"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_10120",
    "data-name": "Gruppe 10120",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_51",
    "data-name": "Vereinigungsmenge 51",
    className: "cls-1",
    d: "M17.756,59.324a5.678,5.678,0,0,1-5.672-5.672V49.094H5.669A5.673,5.673,0,0,1,0,43.426V5C0,2.011,2.279,0,5.669,0H23.806c3.119,0,4.91,1.825,4.91,5v24.85H56.179a5.678,5.678,0,0,1,5.67,5.673V53.652a5.676,5.676,0,0,1-5.67,5.672Zm-2.895-23.8V53.655a2.9,2.9,0,0,0,2.895,2.892H56.179a2.9,2.9,0,0,0,2.892-2.892V35.526a2.9,2.9,0,0,0-2.892-2.895H17.756A2.9,2.9,0,0,0,14.862,35.526ZM2.778,5V43.426a2.893,2.893,0,0,0,2.892,2.89h6.415V41.685H10.652a1.389,1.389,0,1,1,0-2.778h1.432v-3.38a5.68,5.68,0,0,1,5.672-5.673h8.182V5c0-1.62-.579-2.223-2.132-2.223H5.669C4.993,2.781,2.778,2.941,2.778,5ZM19.364,47.017V40.31a1.389,1.389,0,1,1,2.778,0v6.707a1.389,1.389,0,0,1-2.778,0Zm34.361-8.575V36.588a1.39,1.39,0,0,1,2.78,0v1.854a1.39,1.39,0,1,1-2.78,0Zm-.031-13.268L47.868,20.32a1.445,1.445,0,0,1-.372-1.813,1.39,1.39,0,0,1,2.093-.37L53.3,21.226V15.214a10.581,10.581,0,0,0-10.58-10.58h-7.98a1.39,1.39,0,0,1-1.369-1.623A1.439,1.439,0,0,1,34.81,1.856h7.905A13.359,13.359,0,0,1,56.076,15.214v6.012l3.706-3.089a1.389,1.389,0,1,1,1.778,2.135l-5.882,4.9a1.553,1.553,0,0,1-1.984,0ZM6.949,8.338a1.389,1.389,0,1,1,0-2.778H8.8a1.389,1.389,0,1,1,0,2.778Z",
    transform: "translate(0 -0.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipe);
export default __webpack_public_path__ + "static/media/swipe.8f263c5bddd9d7cf44d3ac81e9710672.svg";
export { ForwardRef as ReactComponent };